export default {
  AtualizarValorRecorrencia: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "atualizar-valor-recorrencia"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/AtualizarValorRecorrencia.js
// module id = FiSG
// module chunks = 16